<label class="card-selectable mb-0 h-100" [attr.for]="inputID()">
  <div class="row gx-2">
    <div class="col">
      <ng-content />
    </div>
    <div class="col-auto">
      <input
        data-test="mwe-card-selectable-checkbox"
        [attr.id]="inputID()"
        [ngClass]="{
          'is-invalid': isInvalid(),
          'form-check-readonly': readonly(),
        }"
        [disabled]="disabled()"
        [readonly]="readonly()"
        class="form-check-input"
        type="checkbox"
        [checked]="isSelected()"
        (click)="toggle()"
        [attr.aria-invalid]="isInvalid()"
        mweClickPreventDefault
        [ignorePreventClickDefault]="!readonly()"
        [attr.tabindex]="readonly() ? '-1' : null"
      />
    </div>
  </div>
</label>
